import React from "react";

import Price from "@atoms/Price";

import Discounts from "@molecules/Discounts";

interface IProps {
  refundAmount?: number;
  shippingFee?: number;
  taxAmount?: number;
  dutyAmount?: number;
  returnShippingFee?: number;
  totalAmount?: number;
  originalTotalAmount?: number;
  codeDiscountAmount?: number;
  autoDiscountAmount?: number;
  autoDiscountTitle: string;
  codeDiscountTitle: string;
}

export default function OrderPaymentInfo({
  refundAmount = 0,
  shippingFee = 0,
  taxAmount = 0,
  dutyAmount = 0,
  returnShippingFee = 0,
  totalAmount = 0,
  originalTotalAmount = 0,
  codeDiscountAmount = 0,
  autoDiscountAmount = 0,
  autoDiscountTitle,
  codeDiscountTitle,
}: IProps) {
  return (
    <>
      <div className="flex justify-between">
        <span className="uppercase">Subtotal</span>
        <Price price={originalTotalAmount} />
      </div>

      <div className="flex justify-between">
        <span className="uppercase">Shipping</span>
        <Price price={shippingFee && shippingFee > 0 ? shippingFee : 0} />
      </div>

      {dutyAmount > 0 && (
        <div className="flex justify-between">
          <span className="uppercase">Duties</span>
          <Price price={dutyAmount && dutyAmount > 0 ? dutyAmount : 0} />
        </div>
      )}

      {taxAmount > 0 && (
        <div className="flex justify-between">
          <span className="uppercase">Taxes</span>
          <Price price={taxAmount && taxAmount > 0 ? taxAmount : 0} />
        </div>
      )}

      <Discounts
        autoDiscountAmount={autoDiscountAmount}
        autoDiscountTitle={autoDiscountTitle}
        codeDiscountAmount={codeDiscountAmount}
        codeDiscountTitle={codeDiscountTitle}
      />

      <div className="flex justify-between">
        <span className="uppercase">Total</span>
        <Price price={totalAmount} />
      </div>

      {returnShippingFee > 0 && (
        <div className="flex justify-between">
          <span className="uppercase">Return shipping</span>
          <Price price={returnShippingFee} />
        </div>
      )}

      {refundAmount > 0 && (
        <div className="flex justify-between">
          <span className="uppercase">Refunded</span>
          <Price isNegative price={refundAmount} />
        </div>
      )}
    </>
  );
}
